import React from 'react';
import { classnames } from '../../../../utils/classnames';
import PropTypes from 'prop-types';

import Arrow from "../../../../picture/arrow.svg?react";
import ArrowLeft from "../../../../picture/chevron-left.svg?react";
import ArrowRight from "../../../../picture/chevron-right.svg?react";
import BuildingHouse from "../../../../picture/building-house.svg?react";
import Calendar from "../../../../picture/calendar.svg?react";
import Check from "../../../../picture/check-green.svg?react";
import Download from "../../../../picture/download.svg?react";
import ExclamationBlue from "../../../../picture/exclamation-blue.svg?react";
import ExclamationRed from "../../../../picture/exclamation-red.svg?react";
import ExclamationYellow from "../../../../picture/exclamation-yellow.svg?react";
import ExternalLink from "../../../../picture/link-external.svg?react";
import Globe from "../../../../picture/globe.svg?react";
import InfoCircle from "../../../../picture/info-circle.svg?react";
import LinkFolder from "../../../../picture/link-folder.svg?react";
import Lock from "../../../../picture/lock.svg?react";
import MailSend from "../../../../picture/mail-send.svg?react";
import MapPin from "../../../../picture/map-pin.svg?react";
import Minus from "../../../../picture/minus-white.svg?react";
import Plus from "../../../../picture/plus-white.svg?react";
import QR from "../../../../picture/qr.svg?react";
import Refresh from "../../../../picture/refresh.svg?react";
import SubGroup from "../../../../picture/subdirectory-right.svg?react";
import Ticket from "../../../../picture/Ticket.svg?react";
import Timer from "../../../../picture/timer.svg?react";
import Upload from "../../../../picture/upload.svg?react";
import UserCircle from "../../../../picture/User-circle.svg?react";
import CheckSimple from "../../../../picture/check-simple.svg?react";
import Cross from "../../../../picture/cross-close.svg?react";
import Receipt from "../../../../picture/receipt.svg?react";
import Reset from "../../../../picture/reset.svg?react";
import RotateLeft from "../../../../picture/rotate-left.svg?react";
import RotateRight from "../../../../picture/rotate-right.svg?react";
import Search from "../../../../picture/search.svg?react";
import ZoomIn from "../../../../picture/zoom-in.svg?react";
import ZoomOut from "../../../../picture/zoom-out.svg?react";
import Grid from "../../../../picture/grid.svg?react";
import List from "../../../../picture/list-ul.svg?react";
import LogOut from "../../../../picture/log-out.svg?react";
import AppleWalletFR from "../../../../picture/FR_apple_wallet.svg?react";
import AppleWalletEN from "../../../../picture/EN_apple_wallet.svg?react";
import GoogleWalletFR from "../../../../picture/FR_google_wallet.svg?react";
import GoogleWalletEN from "../../../../picture/EN_google_wallet.svg?react";
import WhatsApp from "../../../../picture/whatsapp.svg?react";
import Share from "../../../../picture/share.svg?react";
import Telegram from "../../../../picture/telegram.svg?react";
import Messenger from "../../../../picture/messenger.svg?react";
import SMS from "../../../../picture/sms.svg?react";
import PurchaseTag from "../../../../picture/purchase-tag.svg?react";
import Edit from "../../../../picture/Edit.svg?react";
import EditBlue from "../../../../picture/edit-blue.svg?react";
import Rotate from "../../../../picture/bx-rotate-left.svg?react";
import Cart from "../../../../picture/cart.svg?react";
import Group from "../../../../picture/group.svg?react";
import WalletPay from "../../../../picture/wallet-pay.svg?react";
import PaperPlane from "../../../../picture/paper-plane.svg?react";
import Time from "../../../../picture/time.svg?react";
import Mobile from "../../../../picture/mobile.svg?react";
import RedCross from "../../../../picture/red-cross.svg?react";
import IdCard from "../../../../picture/idCard.svg?react";
import Transfer from "../../../../picture/transfer.svg?react";
import Copy from "../../../../picture/copy.svg?react";


import './icon.css';
import { useTranslation } from 'react-i18next';

const MAPPING_ICON = {
    arrow: Arrow,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    building: BuildingHouse,
    calendar: Calendar,
    check: Check,
    download: Download,
    exclamationBlue: ExclamationBlue,
    exclamationRed: ExclamationRed,
    exclamationYellow: ExclamationYellow,
    externalLink: ExternalLink,
    globe: Globe,
    infoCircle: InfoCircle,
    linkfolder: LinkFolder,
    lock: Lock,
    mapPin: MapPin,
    minus: Minus,
    plus: Plus,
    qr: QR,
    refresh: Refresh,
    sendMail: MailSend,
    subGroup: SubGroup,
    ticket: Ticket,
    timer: Timer,
    upload: Upload,
    userCircle: UserCircle,
    checkSimple: CheckSimple,
    cross: Cross,
    receipt: Receipt,
    reset: Reset,
    rotateLeft: RotateLeft,
    rotateRight: RotateRight,
    search: Search,
    zoomIn: ZoomIn,
    zoomOut: ZoomOut,
    grid: Grid,
    list: List,
    logout: LogOut,
    frAppleWallet: AppleWalletFR,
    enAppleWallet: AppleWalletEN,
    frGoogleWallet: GoogleWalletFR,
    enGoogleWallet: GoogleWalletEN,
    whatsapp: WhatsApp,
    share: Share,
    telegram: Telegram,
    messenger: Messenger,
    sms: SMS,
    purchaseTag: PurchaseTag,
    edit: Edit,
    editBlue: EditBlue,
    rotate: Rotate,
    cart: Cart,
    group: Group,
    walletPay: WalletPay,
    paperPlane: PaperPlane,
    time: Time,
    mobile: Mobile,
    redCross: RedCross,
    idCard: IdCard,
    transfer: Transfer,
    copy: Copy
};

/**
 * This component provides a way to render an icon (from the available list) asynchronously (lazy).
 */
const Icon = ({ name, className, size = 'regular', onClick = undefined }) => {
    const { t, i18n } = useTranslation();
    const fallbackValue = <span />;

    if (!name) {
        return null;
    }

    return (
        <React.Suspense fallback={fallbackValue}>
            {Object.keys(MAPPING_ICON).includes(name)
                ? (
                    <div
                        className={classnames('neo-icon-wrapper', `neo-icon-wrapper-${size}`, className, {
                            'neo-icon-wrapper-clickable': onClick
                        })}
                        onClick={onClick}>
                        {React.createElement(MAPPING_ICON[name], {
                            className: 'neo-icon',
                            alt: i18n.exists(`widget.alt-icons.${name}`) ? t(`widget.alt-icons.${name}`) : 'icon',
                            'aria-label': '',
                            'aria-hidden': !onClick
                        })}
                    </div>
                ) : (
                    fallbackValue
                )}
        </React.Suspense>
    );
};

Icon.propTypes = {
    /**
     * The name of the icon to display, must exist in the list of the available icons.
     */
    name: PropTypes.oneOf(Object.keys(MAPPING_ICON)).isRequired,
    className: PropTypes.string,
    size: PropTypes.string,
    ariaHidden: PropTypes.oneOfType(PropTypes.bool, null),
};

Icon.defaultProps = {
    className: null,
    size: 'regular'
};

export default Icon;
